import React, { useEffect, useRef } from 'react';
import getGraph from '../../api/getGraph';

const Graph = ({ url, wcd, wct, wcs, type }) => {
  const image = useRef();

  useEffect(() => {
    if (url && typeof url !== 'undefined' && type && wcd) {
      getGraph(url, type, {
        wcd,
        wct,
        wcs,
      }).then((blob) => {
        if (blob) {
          image.current.src = URL.createObjectURL(blob);
          image.current.style.display = 'block';
        }
      });
    };
  }, [url, wcd, wct, wcs, type]);

  return (
    <>
      <img alt="" ref={image} style={{ display: 'none' }} />
    </>
  );
};

export default Graph;
